var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("fragment", [
    _c(
      "div",
      { staticClass: "row location-search-block__search floating-label" },
      [
        _c("div", { staticClass: "col-12" }, [
          _c(
            "span",
            { staticClass: "pill large" },
            [
              _c("label", { staticClass: "location-search-block__label" }, [
                _vm._v(_vm._s(_vm.placeholdertext))
              ]),
              _vm._v(" "),
              _c("gmap-autocomplete", {
                ref: "place",
                attrs: {
                  type: "search",
                  "select-first-on-enter": true,
                  "aria-label": "Search",
                  placeholder: "",
                  "aria-describedby": "search-by-location-autocomplete",
                  options: {
                    bounds: {
                      north: 39.5,
                      south: 27.3,
                      east: -83.52,
                      west: -98.88
                    },
                    strictBounds: true
                  }
                },
                on: {
                  place_changed: _vm.setPlace,
                  blur: function($event) {
                    return _vm.toggleLabel($event)
                  },
                  focus: function($event) {
                    return _vm.toggleLabel($event)
                  }
                }
              }),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "location-search-block__filters-search",
                  on: { click: _vm.setPlaceBySubmit }
                },
                [
                  _c("img", {
                    attrs: {
                      src: "/Static/assets/images/search_icon_red.svg",
                      alt: "search"
                    }
                  })
                ]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "p",
            {
              staticClass: "sr-only",
              attrs: { id: "search-by-location-autocomplete" }
            },
            [
              _vm._v(
                "Begin typing to search, the field will be completed as you type. Use arrow keys to navigate, Enter to select."
              )
            ]
          )
        ])
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }